import {Component, ContentChild, ElementRef, Input} from '@angular/core';
import {TranslatePipe} from "@ngx-translate/core";
import {NgClass} from "@angular/common";


export interface ISummaryItem {
    icon: string;
    title: string;
    url: string;
    iconBack?: string;
    iconClass?: string;
    cardStyle?: Partial<CSSStyleDeclaration>;
}

@Component({
    selector: 'msf-list-page-wrapper',
    imports: [
        TranslatePipe,
        NgClass,
    ],
    templateUrl: './list-page-wrapper.html',
    styleUrl: './list-page-wrapper.scss',
    standalone: true
})
export class ListPageWrapper {

    @Input() title: string = '';
    @Input() items: ISummaryItem[] = [];
    @Input() separator = true
    @Input() rightBackground = true

    @Input() leftSize: string = '9';
    @Input() rightSize: string = '3';

    @ContentChild('title', {read: ElementRef}) titleEl?: ElementRef;
    @ContentChild('left', {read: ElementRef}) leftEl?: ElementRef;
    @ContentChild('right', {read: ElementRef}) rightEl?: ElementRef;


    get hasTitle() {
        return this.titleEl;
    }

    get hasLeft() {
        return this.leftEl;
    }

    get hasRight() {
        return this.rightEl;
    }

}
